<template>
  <div v-if="authStatus === 'authenticating'" class="app-loader">
    <div class="app-loader__card">
      <div class="app-loader__spinner"></div>
      <p class="app-loader__text">Cargando sesion...</p>
    </div>
  </div>
  <router-view v-else />
</template>

<script>
import useAuth from './modules/auth/composables/useAuth'

export default {
  setup() {
    const { authStatus, checkAuthStatus } = useAuth()

    checkAuthStatus()

    return {
      authStatus
    }
  }
}
</script>

<style scoped>
.app-loader {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at top, rgba(13, 202, 240, 0.18), transparent 35%),
    linear-gradient(180deg, #f5fcff 0%, #eef7fb 100%);
}

.app-loader__card {
  min-width: 220px;
  padding: 2rem;
  text-align: center;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 18px 40px rgba(44, 62, 80, 0.12);
}

.app-loader__spinner {
  width: 48px;
  height: 48px;
  margin: 0 auto 1rem;
  border: 4px solid rgba(13, 202, 240, 0.2);
  border-top-color: #0dcaf0;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

.app-loader__text {
  margin: 0;
  color: #2c3e50;
  font-weight: 700;
  letter-spacing: 0.02em;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
